var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37404 2.35329C9.72299 2.01554 10.277 2.01554 10.6259 2.35329L15.1259 6.70884C15.4831 7.05453 15.4924 7.62431 15.1467 7.98146C14.801 8.33862 14.2312 8.34791 13.874 8.00222L9.99998 4.25251L6.12591 8.00222C5.76875 8.34791 5.19898 8.33862 4.85329 7.98146C4.50759 7.62431 4.51689 7.05453 4.87404 6.70884L9.37404 2.35329ZM4.85329 12.0185C5.19898 11.6613 5.76875 11.652 6.12591 11.9977L9.99998 15.7474L13.874 11.9977C14.2312 11.652 14.801 11.6613 15.1467 12.0185C15.4924 12.3756 15.4831 12.9454 15.1259 13.2911L10.6259 17.6467C10.277 17.9844 9.72299 17.9844 9.37404 17.6467L4.87404 13.2911C4.51689 12.9454 4.50759 12.3756 4.85329 12.0185Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.aab8dfa5cbf99c65dae6dda8a539ffff.svg";
export { ForwardRef as ReactComponent };